import { getPageMessage } from '../../shared/constants/pageMessages';
import { WorkImportCandidateData } from '../../shared/dto/EntityRepository';
import { WorkContentMode } from '../../shared/enum/EnumRepository';
import { resolveWorkMaterial, resolveWorkTitle } from '../../shared/util/workDisplayText';

export const getCandidateTitle = (
  candidate: WorkImportCandidateData,
  mode: WorkContentMode,
): string => resolveWorkTitle(
  {
    title: candidate.title ?? '',
    titleEn: candidate.titleEn ?? '',
  },
  mode,
  true,
).trim() || getPageMessage('WORK_COPY_IMPORT_UNTITLED');

export const getCandidateMaterial = (
  candidate: WorkImportCandidateData,
  mode: WorkContentMode,
): string => resolveWorkMaterial(
  {
    material: candidate.material ?? '',
    materialEn: candidate.materialEn ?? '',
  },
  mode,
  true,
).trim() || '-';
